import React, { ReactNode, useEffect, useState } from "react";
import { ReactComponent as ArrowDownIcon } from "../assets/icons/arrow_down.svg";
import useModal from "../domain/Develop/Program/useModal";
import { ReactComponent as CloseIcon } from "../assets/icons/close.svg";

type Props = {
  actionIcons?: ReactNode[];
  title: string;
  expands?: boolean;
  className?: string;
  children?: ReactNode;
  onToggle?: any;
  actions?: ReactNode;
};

const SubMenu = (props: Props) => {
  // const { isShowing, openModal, closeModal, closeModalFromParent } = useModal();

  const closeModal = () => {
    props.onToggle(false);
  };
  //   useEffect(() => {
  //     setExpanded(props.expands);
  //   }, [props.expands]);

  //   const toggle = () => {
  //     setExpanded(true);
  //     console.log("State is true now");
  //   };

  return (
    <div className="submenu">
      <div className="submenu-header">
        {/* {!props.actions && <ArrowDownIcon className={isShowing ? "rotated" : ""} />} */}
        <div className="submenu-title">{props.title}</div>
        <div className="submenu-block-button-container">
          {props.actions && props.actions}
        </div>
      </div>
      <div
        // className={`submenu-body ${isShowing && "expanded"} ${props.className}`}
        className={`submenu-body ${props.expands ? "expanded" : "none"} ${
          props.className
        } `}
      >
        <div>
          {/* <div className="close-button-container"> */}
          {/* </div> */}
          <div className="block-modal">
            <div className="block-modal-content-container">
              <div className="close-button-container">
                <button className="submenu-close-button" onClick={closeModal}>
                  <CloseIcon />
                </button>
              </div>
              {props.children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubMenu;
